import useMouseSvg from "@/composables/useMouseSvg";
import ui from "@/store/modules/ui";

export default function usePan() {
  const pan = e => {
    // return if not pressed by the left(main) mouse button
    if (e.button !== 0) return;
    // get svg element (the canvas)
    const elem = e.currentTarget.closest("svg");
    const { pos: mousePosSvg } = useMouseSvg(e);

    let moving = true;
    const rawMousePos = mousePosSvg(e);
    const initPos = ui.viewOffset;
    const initMousePos = [rawMousePos.x, rawMousePos.y];
    let newMousePos = [rawMousePos.x, rawMousePos.y];
    const updateFn = () => {
      // recursively call oneself till mouse is released
      if (moving) requestAnimationFrame(updateFn);
      const offsetX = newMousePos[0] - initMousePos[0];
      const offsetY = newMousePos[1] - initMousePos[1];
      const newPos = [initPos[0] - offsetX, initPos[1] - offsetY];
      ui.setViewOffset(newPos);
    };
    const moveFn = e => {
      const mousePos = mousePosSvg(e);
      newMousePos = [mousePos.x, mousePos.y];
    };
    const stopFn = () => {
      moving = false;
      elem.removeEventListener("mousemove", moveFn);
      elem.removeEventListener("mouseup", stopFn);
    };
    // Call update recursively
    requestAnimationFrame(updateFn);
    moveFn(e);
    // Update point when moving
    elem.addEventListener("mousemove", moveFn);
    // Clean up when releasing mouse
    elem.addEventListener("mouseup", stopFn);
  };
  return {
    pan
  };
}
